<div *ngIf="isBlockedPage" class="atp-preloader-container"
  [class.atp-preloader-container_transparent]="!isPreloaderShow">
  <mat-spinner *ngIf="isPreloaderShow"></mat-spinner>
</div>

<div *ngIf="data" class="atp-history__container">

  <atp-title class="atp-history__title" text="История изменений" beforeIcon="history" notSetInHeader="false">
  </atp-title>

  <div class="atp-history__content">

    <button *ngIf="data.type == 'history'" mat-raised-button color="primary" type="button" (click)="exportInCsv()">Экспорт в CSV</button>

    <mat-paginator [length]="tableData.allCount" [pageSize]="tableData.pageSize" [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="tableData.pageNumber - 1" [showFirstLastButtons]="'true'" (page)="pagination($event)">
    </mat-paginator>

    <table class="atp-history__table" mat-table [dataSource]="dataSource">
      <!-- <table class="atp-dynamic-table-full-crud__table" mat-table [dataSource]="dataSource" matSort
      [matSortActive]="sortInfo.active" [matSortDirection]="sortInfo.direction" matSortDisableClear
      (matSortChange)="sort($event)"> -->

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="atp-history__table-column-header"></th>
        <td mat-cell *matCellDef="let row" class="atp-history__table-column atp-history__table-column_action">
          <mat-icon>{{row.actionIcon}}</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="atp-history__table-column-header">Id события</th>
        <td mat-cell *matCellDef="let row" class="atp-history__table-column atp-history__table-column_id">
          <button mat-button color="primary" type="button" (click)="getItemDetail(row)" [disabled]="!row.haveJson">
            {{row.id}}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="entityId">
        <th mat-header-cell *matHeaderCellDef class="atp-history__table-column-header">Id</th>
        <td mat-cell *matCellDef="let row" class="atp-history__table-column atp-history__table-column_entity-id">
          {{row.entityId}}
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="atp-history__table-column-header">Дата</th>
        <td mat-cell *matCellDef="let row" class="atp-history__table-column atp-history__table-column_date">
          {{row.date | format : 'DateFullTime'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef class="atp-history__table-column-header">Пользователь</th>
        <td mat-cell *matCellDef="let row" class="atp-history__table-column atp-history__table-column_username">
          {{row.userName}}</td>
      </ng-container>

      <ng-container matColumnDef="roleName">
        <th mat-header-cell *matHeaderCellDef class="atp-history__table-column-header">Роль</th>
        <td mat-cell *matCellDef="let row" class="atp-history__table-column atp-history__table-column_role-name">
          {{row.roleName}}</td>
      </ng-container>

      <ng-container *ngIf="data.isShared" matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef class="atp-history__table-column-header">Тип</th>
        <td mat-cell *matCellDef="let row" class="atp-history__table-column atp-history__table-column_type">
          {{row.type}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <ng-container matColumnDef="disclaimer">
        <td mat-footer-cell *matFooterCellDef [colSpan]="7">
          Нет данных для отображения
        </td>
      </ng-container>
      <tr mat-footer-row *matFooterRowDef="['disclaimer']" [style.display]="!isNotData ? 'none' : 'table-row'"></tr>
    </table>

  </div>
  <div class="atp-history__actions">
    <button mat-raised-button type="button" (click)="close()">Закрыть</button>
  </div>
</div>